export const PageScrollPrevent = (() => {
  let scrollPosition = 0;

  return {
    enable() {
      // Save the current scroll position
      scrollPosition = window.scrollY || document.documentElement.scrollTop;
      // Prevent scrolling
      document.body.style.overflow = "hidden";
      document.body.style.width = "100%";
    },

    disable() {
      const container = document.querySelector<HTMLElement>("#pageContainer");
      // Restore scrolling
      document.body.style.removeProperty("overflow");
      document.body.style.removeProperty("width");

      if (container) {
        container.style.removeProperty("top");
      }
      // Restore the scroll position
      window.requestAnimationFrame(() => {
        window.scrollTo(0, scrollPosition);
      });
    },
  };
})();
